import React from 'react';
import classnames from 'classnames';
import styles from './aiChat.module.scss';
import { Button } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import restFactory from 'v2/utils/restFactory';
import { AIConversation } from 'v2/models';

interface AIErrorMessageProps {
  aiConversation: AIConversation;
}

const AIErrorMessage = ({ aiConversation }: AIErrorMessageProps) => {
  const queryClient = useQueryClient();
  const { mutate: retryMessage, isLoading } = useMutation(
    async () => {
      return await restFactory.post(
        `/dj/api/v1/ai_conversation/${aiConversation.id}/reprocess_conversation/`,
        {}
      );
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries('AIConversationList');
        queryClient.refetchQueries([
          'AIConversationMessages',
          aiConversation.id,
        ]);
      },
      onError: () => {
        toast.error('Error sending message.');
      },
    }
  );

  return (
    <div className={classnames(styles.infoMessage, styles.errorMessage)}>
      <p>There was an error generating a response.</p>
      <Button type="button" onClick={() => retryMessage()} disabled={isLoading}>
        Try again
      </Button>
    </div>
  );
};

export default AIErrorMessage;
